import 'prop-types';
import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';

var ForwardRef = function ForwardRef(props, ref) {
  var children = props.children,
      onResize = props.onResize;
  var defaultRef = React.useRef();
  var resizeRef = ref || defaultRef;
  var onResizeRef = React.useRef(onResize);
  var resizeObserver = React.useMemo(function () {
    return new ResizeObserver(function (entries) {
      onResizeRef.current({
        width: entries[0].contentRect.width,
        height: entries[0].contentRect.height
      });
    });
  }, []);
  React.useEffect(function () {
    onResizeRef.current = onResize;
  }, [onResize]);
  React.useEffect(function () {
    var current = resizeRef.current;

    if (current) {
      resizeObserver.observe(current);
    }

    return function () {
      return resizeObserver.disconnect();
    };
  }, [resizeRef, resizeObserver]);
  return children({
    ref: resizeRef
  });
};

ForwardRef.displayName = "Resizer";
var Resizer = /*#__PURE__*/React.forwardRef(ForwardRef);

export { Resizer };
